import {
  useSearchBarChartDataQuery,  
} from "../../dashboard/dashBoardApi";
import { Col, Row } from "react-bootstrap";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import useTranslator from "../../../hooks/useTranslator";
import DashboardSection from "../../dashboard/components/DashboardSection";
import "../../dashboard/components/dashboard-sections.css";
import { BarChartIconSvg } from "../../../svgFiles/BarChartIconSvg";

export const ReceivingCharts = ({ startDate, endDate }) => {
  const { _t } = useTranslator();
  const { data: barChartData } = useSearchBarChartDataQuery({    
    start_date: startDate,
    end_date: endDate,
  });  

  const hasBarData =
    Array.isArray(barChartData?.data?.series) &&
    barChartData.data.series.length > 0;  

  const noDataLabel = _t("no_data", "No Data");
  const totalCasesLabel = _t("total_cases", "Total Cases");
  const casesLabel = _t("cases", "Cases");

  const options = {
    chart: { type: "column" },
    title: { text: null, align: "left" },
    xAxis: {
      categories: hasBarData ? barChartData.data.categories : [noDataLabel],
      labels: { style: { fontSize: "12px", color: "#8C97A7" } },
    },
    yAxis: { title: { text: casesLabel } },
    legend: { align: "center", verticalAlign: "top", layout: "horizontal" },
    tooltip: { shared: true },
    plotOptions: {
      column: {
        grouping: true,
        borderWidth: 0,
        dataLabels: { enabled: false },
      },
    },
    series: hasBarData
      ? barChartData.data.series.map((series) => ({
          name: _t(series?.name, series?.name) || "",
          data: Array.isArray(series?.data) ? [...series.data] : [],
          color:
            series?.name === "Total Cases"
              ? "#FFD699"
              : series?.name === "Accepted Cases"
              ? "#98D89D"
              : "#FFB3B3",
        }))
      : [{ name: noDataLabel, data: [0], color: "#E8E8E8" }],
  };


  return (
    <DashboardSection title={<span className="d-flex align-items-center gap-2"><BarChartIconSvg size={18} color="#60a5fa" />{_t("supplier_data_overview", "Supplier Data Overview")}</span>}>
      <div className="cmn_card">
        <div className="p-2">
          <HighchartsReact highcharts={Highcharts} options={options} />
        </div>
      </div>
    </DashboardSection>
  );
};
